import React from 'react';
import { connect } from 'react-redux';

import swimmingImage from './img/swimming.svg';
// import barImage from './img/bar.svg';
// import restaurantImage from './img/restaurant.svg';
// import roomServiceImage from './img/room-service.svg';
// import acImage from './img/ac.svg';
// import fitnessImage from './img/fitness.svg';
// import laundryImage from './img/laundry.svg';
// import internetImage from './img/internet.svg';
// import jacuzziImage from './img/jacuzzi.svg';
// import dotsImage from './img/dots.svg';

import HotelNav from '../HotelNav/HotelNav';
import HotelNavItem from '../HotelNav/HotelNavItem/HotelNavItem';

const hotelAmenity = (props) => {
    const amenitiesPriorityDOM = [
        'Free Wifi',
        'Free Breakfast',
        'WIFI',
        'Parking',
        'Breakfast Services',
        'Room service',
        'Swimming pool',
        'Private beach',
        'Jacuzzi',
        'Spa services onsite',
        'Massage',
        'Airport transportation',
        'Poolside Bar',
        'Bar',
        'Restaurant',
        'Health club',
        'Fitness Centre',
        'Gardens',
        'Night club',
        'Arcade/game room',
        'ATM/banking',
        'Internet Access',
        'Laundry facilities',
        'Travel counter',
        'Business center',
        'Babysitting or child care',
        'Suitable for children',
        'Central Air Condition',
        'Beach Nearby',
        'Full Services Health'
    ];

    const amenities = [...props.amenities];

    for(let i = 0; i < props.amenities.length; i++) {
        if(amenitiesPriorityDOM.includes(props.amenities[i].name)) {
            const amenityIndex = amenitiesPriorityDOM.findIndex((amenity) => amenity === props.amenities[i].name);
            amenities[i].priority = amenityIndex + 1;
        } else {
            amenities[i].priority = -1; 
        }
    }

    return (
        <HotelNav type='horizontal'>
            {amenities.map((amenity, index) => {
                if(amenity.priority > 0) {
                    return (
                        <HotelNavItem key={index} image={swimmingImage}>{amenity.name}</HotelNavItem>
                    );
                }
                return null;
            })}
        </HotelNav>
    );
};

const mapStateToProps = state => {
    return {
        amenities: state.hotels.amenities
    }
}

export default connect(mapStateToProps)(hotelAmenity);


// WEBPACK FOOTER //
// ./src/components/HotelDetail/HotelAmenity/HotelAmenity.js